import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const Switcher = (props) => {
	const { label, ...rest } = props;

	return (
		<FormControlLabel
			control={<Switch defaultChecked />}
			label={label}
			labelPlacement="end"
			{...rest}
		/>
	);
};

Switcher.propTypes = {
	label: PropTypes.node,
};

export default Switcher;
